module.exports = __webpack_public_path__ + "img/live-panel-white.ae56f8b9.svg";